import {stablecoins} from '~/config';
import {TokenAccount} from '~/shared/api/legacy_services/Assets/Assets';
import {AccountLikeToken} from '../domain';

export const getPrivateEquityAccounts = (tokens: TokenAccount[]): AccountLikeToken[] =>
    tokens.filter(acc => !stablecoins.includes(acc.currency)).map(AccountLikeToken.fromTokenAccount);
